import { Box, Button, Fade, Typography } from "@mui/material";
import React from "react";
import { termsData } from "./termsData";
import { useNavigate } from "react-router-dom";

const TermsAndServices = () => {
  let navigate = useNavigate();
  return (
    <Fade in={true}>
      <Box style={{ padding: "20px", width: "90%", margin: "auto" }}>
        <Button
          size="small"
          sx={{
            backgroundColor: "primary.main",
            ":hover": { background: "#502E61" },
            color: "white",
          }}
          onClick={() => navigate("/Create_Account")}
        >
          Back to Signup
        </Button>
        <Typography
          variant="h4"
          style={{ fontWeight: "bold", margin: "10px 0px" }}
        >
          Terms of Service
        </Typography>
        <Typography variant="h4" style={{ fontWeight: "bold" }}>
          This is an Agreement between you or the entity you represent ("You" or
          "Your") and TheX TechVent Private Limited ("TheX"), governing your use
          of TheX's suite of online business productivity and collaboration
          software.
        </Typography>
        {termsData.map((terms) => (
          <>
            <Typography
              variant="h2"
              style={{ fontWeight: "bold", margin: "10px 0px" }}
            >
              {terms.title}
            </Typography>
            <Typography variant="h5">
              <div dangerouslySetInnerHTML={{ __html: terms.description }} style={{fontSize:"14px"}}/>
            </Typography>
            {terms.subList &&
              terms.subList.length > 0 &&
              terms.subList.map((list) => (
                <ul key={list}>
                  <li style={{ fontSize: "14px", fontWeight: "400" }}>
                    {list}
                  </li>
                </ul>
              ))}
          </>
        ))}
      </Box>
    </Fade>
  );
};

export default TermsAndServices;
